import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
// hooks
import useSettings from '../../hooks/useSettings';
import useResponsive from '../../hooks/useResponsive';
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
// config
import { HEADER, NAVBAR } from '../../config';
//
import DashboardHeader from './header';
import NavbarVertical from './navbar/NavbarVertical';
import NavbarHorizontal from './navbar/NavbarHorizontal';
import useModalImageStore from 'src/store/imageModal';
import { DialogAnimate } from 'src/components/animate';
import GeneralFormsModal from 'src/components/general/GeneralFormsModal';

// ----------------------------------------------------------------------

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})(({ collapseClick, theme }) => ({
  flexGrow: 1,
  paddingTop: HEADER.MOBILE_HEIGHT + 24,
  // paddingBottom: HEADER.MOBILE_HEIGHT + 24 ,
  paddingBottom: 30,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 16,
    paddingRight: 16,
    // todo
    // paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    paddingTop: 24,
    // paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    transition: theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter,
    }),
    ...(collapseClick && {
      marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
    }),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { collapseClick, isCollapse } = useCollapseDrawer();

  const { themeLayout, themeMode } = useSettings();

  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  const { imgSrc, isOpenModalImage, setIsOpenModalImage, imgSize: modalImageSize } = useModalImageStore();

  const verticalLayout = themeLayout === 'vertical';

  return (
    <>
      {verticalLayout ? (
        <>
          <DashboardHeader onOpenSidebar={() => setOpen(true)} verticalLayout={verticalLayout} />

          {isDesktop ? <NavbarHorizontal /> : <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />}

          <Box
            className={themeMode}
            component="main"
            sx={{
              px: { lg: 2 },
              // todo
              // pt: {
              //   xs: `${HEADER.MOBILE_HEIGHT + 24}px`,
              //   lg: `${HEADER.DASHBOARD_DESKTOP_HEIGHT + 80}px`,
              // },
              // pb: {
              //   xs: `${HEADER.MOBILE_HEIGHT + 24}px`,
              //   lg: `${HEADER.DASHBOARD_DESKTOP_HEIGHT + 24}px`,
              // },
            }}
          >
            <Outlet />
          </Box>
        </>
      ) : (
        <Box
          className={themeMode}
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          <DashboardHeader isCollapse={isCollapse} onOpenSidebar={() => setOpen(true)} />

          <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

          <MainStyle collapseClick={collapseClick}>
            <Outlet />
          </MainStyle>
        </Box>
      )}

      <DialogAnimate
        open={isOpenModalImage}
        onClose={() => setIsOpenModalImage(false)}
        sx={{ backgroundColor: 'transparent' }}
        maxWidth={modalImageSize}
      >
        <img
          alt="image"
          src={imgSrc || '/images/fallback.jpeg'}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/images/fallback.jpeg';
          }}
        />
      </DialogAnimate>
      <GeneralFormsModal />
    </>
  );
}
